import useFetch from '../http/api'

export default function ProductsList() {
	const { data, loading, error, refetch } = useFetch(
		`${process.env.API_URL}/produtos?page=1&per_page=2`
	)

	if (loading) return <p>Carregando produtos...</p>
	if (!data) return <p>Não há produtos</p>

	return (
		<div className="grid grid-cols-12 gap-6">
			{data.data.map((product) => (
				<div key={product.id} className="col-span-4">
					<img src={product.image} alt={product.title} />
					{product.title}
				</div>
			))}
		</div>
	)
}
